import React, { memo } from "react";
import GridCategoryVideos from "../GridCategoryVideos/GridCategoryVideos";
import FilterBadges from "../FilterBadges/FilterBadges";
import { useSelector } from "react-redux";
import { selectApp } from "../../app/appSlice";

const GridVideos = memo(({ categories, spatialElementId, slideView, filterEnabled }) => {
  const selectedCategory = useSelector(selectApp).selectedFilterCategory;
  const { page, isLoading } = useSelector(selectApp);

  return (
    <div id={spatialElementId} >
      {filterEnabled && page.name !== "Home" && !isLoading && <FilterBadges data={categories} /> }
      {filterEnabled ? (
        // Show categories in separate rows
        categories.map((category, index) => (
          <GridCategoryVideos
            key={index}
            data={category}
            cIndex={index}
            hidden={!slideView && category.filter !== selectedCategory}
            filterEnabled={filterEnabled}
          />
        ))
      ) : (
        // Show all categories in a single row/grid
        <GridCategoryVideos
          key={0}
          data={{
            category_id: 12,
            category_name: "Kids",
            category_tamil: "Kids",
            category_name_tamil: "குழந்தைகள்",
            series: [].concat(...categories.map(category => category.series)) // Merging all series into one row
          }}
          cIndex={0}
          filterEnabled={filterEnabled}
        />
      )}
    
    </div>
  );
});

export default GridVideos;
